import 'polyfills';

import ReactOnRails from 'react-on-rails';

import View from '../components/Builder/View';
import FeatureFlagAlert from '../components/FeatureFlag/FeatureFlagAlert';
import Footer from '../components/OC/footer';
import { ProvidedMegaNav as MegaNav } from '../components/OC/meganav';
import RichText from '../components/OC/oc-rich-text';
import Text from '../components/OC/oc-text';
import warrantyClaimStore from '../components/Warranty/WarrantyClaimForm/redux/store';
import WarrantyClaimsForm from '../components/Warranty/WarrantyClaimForm/warranty-claims.jsx';
import CrossingLocale from '../components/location/CrossingLocale';
import Switcher from '../components/location/Switcher';

ReactOnRails.registerStore({
  warrantyClaimStore,
});

ReactOnRails.register({
  WarrantyClaimsForm: WarrantyClaimsForm,
  'Location::Switcher': Switcher,
  'Location::Crossinglocale': CrossingLocale,
  'FeatureFlag::Featureflagalert': FeatureFlagAlert,
  'Builder::View': View,
  'OC::Text': Text,
  'OC::Footer': Footer,
  'OC::Richtext': RichText,
  MegaNav,
});
